/**
 * RecentActivityTimeline Component
 *
 * Chronological activity stream showing recent actions across all modules.
 * Based on DASHBOARD_FUNCTIONAL_SPEC.md - Phase 2 implementation.
 *
 * TODO: Build real activity feed via getRecentActivity Cloud Function.
 * Currently shows an empty state until that backend is implemented.
 */

import { useNavigate } from 'react-router-dom';
import { Clock, FolderPlus } from 'lucide-react';
import { useCaseFile } from '../../contexts/CaseFileContext';

interface RecentActivityTimelineProps {
  activeCaseFileId?: string;
}

export function RecentActivityTimeline(_props: RecentActivityTimelineProps): JSX.Element {
  const navigate = useNavigate();
  const { caseFiles } = useCaseFile();
  const hasCaseFiles = caseFiles.length > 0;

  return (
    <div className="card">
      {/* Header */}
      <div className="card-header flex items-center gap-2">
        <Clock size={18} className="text-evergreen" />
        <h3 className="font-semibold text-ink">Recent Activity</h3>
      </div>

      <div className="card-body">
        <div className="text-center py-8">
          <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-soft-neutral flex items-center justify-center">
            {hasCaseFiles ? (
              <Clock size={24} className="text-muted" />
            ) : (
              <FolderPlus size={24} className="text-muted" />
            )}
          </div>
          {hasCaseFiles ? (
            <>
              <p className="text-muted text-sm">No recent activity</p>
              <p className="text-xs text-muted mt-1">
                Your activity will appear here as you upload documents, create deadlines, and log care notes.
              </p>
            </>
          ) : (
            <>
              <p className="text-muted text-sm">No recent activity yet</p>
              <p className="text-xs text-muted mt-1">
                Create a CaseFile to get started!
              </p>
              <button
                onClick={() => navigate('/create-casefile')}
                className="mt-3 text-sm text-evergreen hover:text-deep-forest font-medium transition-colors"
              >
                Create your first CaseFile
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default RecentActivityTimeline;
